import { render, staticRenderFns } from "./navGroup.vue?vue&type=template&id=1fe7d66b&scoped=true&"
import script from "./navGroup.vue?vue&type=script&lang=js&"
export * from "./navGroup.vue?vue&type=script&lang=js&"
import style0 from "./navGroup.vue?vue&type=style&index=0&id=1fe7d66b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7d66b",
  null
  
)

export default component.exports